'use strict';

var _require = require('../constants'),
    ACTIVE = _require.tokenStates.ACTIVE;

var isTokenExpired = function isTokenExpired(token) {
    var expiresOn = token.expiresOn;

    var now = new Date();
    var expiresOnDate = new Date(expiresOn);

    if (expiresOnDate <= now) {
        return true;
    }

    return false;
};

var isTokenActive = function isTokenActive(token) {
    var state = token.state;


    if (state === ACTIVE) {
        return true;
    }

    return false;
};

var isTokenValid = function isTokenValid(token) {
    return isTokenActive(token) && !isTokenExpired(token);
};

module.exports = {
    isTokenExpired: isTokenExpired,
    isTokenActive: isTokenActive,
    isTokenValid: isTokenValid
};